import { Component, OnInit,Input } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-success',
  templateUrl: './success.component.html'
 
})
export class SuccessComponent implements OnInit {
  @Input() message: string;
  @Input() isDisplaypopup: boolean;
  constructor() { }

  ngOnInit(): void {



  }

  showPopUp()
  {
    $("#myModal").modal('show');

  }

}
